// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border: 1px solid var(--ion-item-border-color);
}

ion-modal {
  --width: 290px;
  --height: 400px;
  --border-radius: 8px;
}

ion-list {
  background: transparent;
}
ion-list .item-no-border {
  border: none !important;
  --background: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/invoices/modals/create-note/create-note.page.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;AACJ;;AACA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;AAEJ;;AAAA;EACI,uBAAA;AAGJ;AAFI;EACI,uBAAA;EACA,oCAAA;AAIR","sourcesContent":["ion-item {\n    border: 1px solid var(--ion-item-border-color);\n}\nion-modal {\n    --width: 290px;\n    --height: 400px;\n    --border-radius: 8px;\n}\nion-list{\n    background: transparent;\n    .item-no-border{\n        border: none !important;\n        --background: transparent !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
